module.exports = __webpack_public_path__ + "static/media/GALAD Вега LED.19531dcc.jpg";